import { get } from 'lodash-es'
import { computed, type ComputedRef, inject } from 'vue'

import { $formKey } from '../utils/injections.ts'
import { type FormErrors } from './useForm.ts'

function getErrorMessages(errors: string[] | FormErrors): string[] {
  if (Array.isArray(errors)) {
    return errors
  }

  const messages: string[] = []

  for (const value of Object.values(errors)) {
    messages.push(...getErrorMessages(value))
  }

  return messages
}

export function useErrors(props: { error: string | string[]; prop?: string }): ComputedRef<string[]> {
  const vform = inject($formKey, undefined)

  const errors = computed(() => {
    const errors: string[] = []

    if (Array.isArray(props.error)) {
      errors.push(...props.error)
    } else if (props.error && props.error.length > 0) {
      errors.push(props.error)
    }

    if (vform && props.prop) {
      const formErrors = get(vform?.form.$errors, props.prop)
      if (formErrors) {
        errors.push(...getErrorMessages(formErrors))
      }
    }

    return errors
  })

  return errors
}
